module.exports = __webpack_public_path__ + "assets/17697ce20e43a2771e3a06dbb16ab3aa.png";